import { render } from "./BusinessUnitTable.vue?vue&type=template&id=7546684a"
import script from "./BusinessUnitTable.vue?vue&type=script&lang=js"
export * from "./BusinessUnitTable.vue?vue&type=script&lang=js"
script.render = render

export default script